import { useApi } from '@axiom/ui';
import { useParams, useLocation } from 'react-router';
import type { Opportunity } from '@axiom/validation';

import { CalendarApi } from '../../api/calendar-api';
import type { InterviewCandidateType } from '../../hooks/useInterviewAvailabilityCandidateData';
import { OpportunityLegacyApi } from '../../api/opportunity-legacy-api';
import { CandidateOpportunityLegacyApi } from '../../api/candidate-opportunity-legacy-api';

const pattern = /^\/(talent|bench)/;

export const useTalentInterviewAvailabilityModalData = (
  candidate: InterviewCandidateType,
  opportunityId?: Opportunity['id']
) => {
  const { id } = useParams();
  const oppId = opportunityId ?? id;

  const location = useLocation();
  const isOppLocation = !pattern.test(location.pathname);
  const shouldCallOppApi = !!(isOppLocation && oppId);

  const [
    { data: opportunity } = { data: undefined },
    { data: positions } = { data: [] },
    { data: [candidateOppData] } = { data: [undefined] },
    { data: calendarData } = { data: undefined },
  ] = useApi(
    shouldCallOppApi ? OpportunityLegacyApi.readOpportunity(oppId) : undefined,
    shouldCallOppApi
      ? OpportunityLegacyApi.readOpportunityPositions(oppId)
      : undefined,
    candidate.id
      ? CandidateOpportunityLegacyApi.readCandidateOpportunities(candidate.id)
      : undefined,
    candidate.calendar?.id
      ? CalendarApi.readCalendar(candidate.calendar.id)
      : undefined
  );

  const position =
    positions.find(pos => {
      return (
        pos.opportunityId === oppId &&
        pos.candidates.find(cand => cand.candidateId === candidate.id)
      );
    }) || undefined;

  return {
    opportunity,
    position,
    calendarData,
    candidateOppData,
  };
};
